import { IconButton } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import SvgToIcon from "../../icons/SvgToIcon";
import { icons } from "../../scenes/stack/environment/icons/iconExport";
import CustomToolTip from "../CustomTooltip";

export default function ExportButton({
  handleExport,
  showToolTip = true,
  ...props
}) {
  const colors = useColors();

  return (
    <CustomToolTip title={showToolTip ? "Export to CSV" : ""} placement="top">
      <IconButton
        sx={{
          background: colors.common_white,
          color: colors.action_active,
          height: "32px",
          width: "32px",
          border: "1px solid " + colors.enabled_stroke,
          borderRadius: "8px",
          textTransform: "none",
          whiteSpace: "nowrap",
          "&:hover": {
            background: colors.grey_8percent,
          },
          ...props.sx,
        }}
        onClick={handleExport}
      >
        <SvgToIcon
          IconLogo={icons.ExportIcon}
          style={{ width: "18px", color: colors.icon_action_active }}
        />
      </IconButton>
    </CustomToolTip>
  );
}
